<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <info-top-right class="card-header" :application="EvaluationForm.application"></info-top-right>

            <evaluation-wizard :is-editable="EvaluationForm.isEditable">
              <template slot="header">
                <h4 class="text-left" slot="title">
                  VI. Final Additional Comments
                </h4>
              </template>

              <evaluation-wizard-tab>
                <page1></page1>
              </evaluation-wizard-tab>

            </evaluation-wizard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Page1 from './Page1';
  import InfoTopRight from '../InfoTopRight';
  import {EvaluationWizard, EvaluationWizardTab} from '@/components';
  import {EvaluationForm} from "@/services";

  export default {
    components: {
      EvaluationWizard,
      EvaluationWizardTab,
      Page1,
      InfoTopRight
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      validateStep(ref) {
        return (this.$refs[ref].validate) ? this.$refs[ref].validate() : true;
      }
    }
  }
</script>